import { useEffect, useState } from 'react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/atoms/Sheet';
import Button from '@/components/atoms/Button';
import FeedbackButton from './FeedbackButton';
import DisappointingReasonList from './DisappointingReasonList';
import { useParams } from 'react-router-dom';
import { logEvent } from '@/etc/firebase';
import useWebview from '@/hooks/V3/useWebview';
import { useSubmitNewsFeedback } from '@/hooks/V3/useSubmitNewsFeedback';

const DisappointingSheet = () => {
  const [selected, setSelected] = useState<string>('');
  const [sheetOpen, setSheetOpen] = useState(false);
  const { submitFeedback } = useSubmitNewsFeedback();
  const { group } = useParams();
  const { postMessage } = useWebview();

  useEffect(() => {
    if (sheetOpen) setSelected('');
  }, [sheetOpen]);

  const handleSubmit = () => {
    if (selected) {
      submitFeedback('disappointing');
      setSheetOpen(false);
    }
    logEvent('submit_news_feedback', {
      feedback: 'disappointing',
      reason: selected,
      targetPage: group,
    });
  };

  // open 상태 변경 시 앱에 전달
  useEffect(() => {
    postMessage({
      action: 'isWebBottomSheetOpen',
      data: String(sheetOpen),
    });
  }, [sheetOpen]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const data = JSON.parse(event.data);

      // android app 에서 back event 발생 시, bottom sheet 닫기
      if (data['isWebBottomSheetOpen']) {
        setSheetOpen(false);
      }
    };

    window.addEventListener('message', handleMessage);
    document.addEventListener('message', handleMessage as EventListener);
    return () => {
      window.removeEventListener('message', handleMessage);
      document.addEventListener('message', handleMessage as EventListener);
    };
  }, []);

  return (
    <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
      <SheetTrigger asChild>
        <FeedbackButton>😕 아쉬워요</FeedbackButton>
      </SheetTrigger>

      <SheetContent
        side="bottom"
        noCloseBtn
        className="overflow-hidden rounded-t-[32px] bg-white px-[20px] pt-[30px]"
      >
        <div className="flex flex-col gap-[40px]">
          <div className="flex flex-col gap-[20px]">
            <DisappointingSheetHeader />
            <DisappointingReasonList selected={selected} onSelect={setSelected} />
          </div>

          <Button
            onClick={handleSubmit}
            variant="default"
            className="h-[52px] rounded-[16px] Body1S16 disabled:bg-gr-200"
            disabled={!selected}
          >
            선택 완료
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default DisappointingSheet;

const DisappointingSheetHeader = () => {
  return (
    <div className="flex flex-col gap-[4px]">
      <h2 className="text-gr-900 Title3S18">어떤 점이 아쉬웠나요?</h2>
      <h4 className="text-gr-600 Body5M14">
        보내주신 의견은 다음 뉴스에 반영할 수 있도록 노력할게요.
      </h4>
    </div>
  );
};
